import { render, staticRenderFns } from "./TransectionDetails.vue?vue&type=template&id=7a184f34&scoped=true"
import script from "./TransectionDetails.vue?vue&type=script&lang=js"
export * from "./TransectionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a184f34",
  null
  
)

export default component.exports